import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=c6a2dd46&scoped=true"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"
import style0 from "./popup.vue?vue&type=style&index=0&id=c6a2dd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a2dd46",
  null
  
)

export default component.exports